import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../shared/alerts/alerts.service';
import { SharedService } from '../shared/shared.service';
import { BASIC, MFA, USER } from '../shared/urls';
import {
  parseCreationOptionsFromJSON,
  create,
  get,
  parseRequestOptionsFromJSON,
  supported,
  AuthenticationPublicKeyCredential,
  RegistrationPublicKeyCredential,
} from '../webauthn-json/browser-ponyfill';
import {
  createResponseToJSON,
  getResponseToJSON,
  PublicKeyCredentialDescriptorJSON,
} from '../webauthn-json/extended';
import { CachedMfaLogo, loadMfaLogo, saveMfaLogo } from './mfa-logo-cache';
declare var bootstrap: any;
@Component({
  selector: 'app-triggermfa',
  templateUrl: './triggermfa.component.html',
  styleUrls: ['./triggermfa.component.scss'],
  standalone: false,
})
export class TriggermfaComponent implements OnInit {
  private cachedLogo: CachedMfaLogo | null = null;
  mfaResponce: any;
  ShowOtpScreen: boolean = false;
  otp: any;
  pushNotificationScreen: boolean = false;
  pushType: any;
  x: number = 0;
  pushModel: any;
  processing: boolean = false;
  userDevices: any = [];
  selectedDeviceId: any;
  selectedDeviceName: any;
  emailSent: any;
  clientDetails: any;
  enableMfas: any;
  myLocation: any = null;
  currentBrowser: any;
  browserVersion: any;
  deviceType: any;
  counter: number = 120;
  verify: boolean = false;
  loading: boolean = true;
  editDeviceDetails: any;
  deviceName: any;
  editDeviceNameModel: any;
  displayOptionType: any;
  isPushNotificationsEnabled: boolean = false;
  isFailedPushNotificationSent: boolean = false;
  isTimeExpired: boolean = false;
  pushModelTemplate: any;
  defaultDevice: boolean = false;
  displayErrMsg: any = null;
  yubiKeyRegistrationObject: any;
  yubicoAuthenticationResponse: any;
  fido2AuthenticationObject: any;
  selcetedManager: any;
  managersList: any = [];
  userManagerId: any = null;
  requestReason: any;
  yubicoManagerAccessRequestScreen: boolean = false;
  isManagerAccessRequired: boolean = false;
  displayWaringMessage: any;
  @ViewChild('search') searchElement: ElementRef;
  locationDetails: any;
  locationData: any;
  isUnderMaintainance: boolean = false;
  isDeviceExists: any;
  isShowInstructionsToUpgrade: boolean = false;
  isNewDeviceRegistered: any;
  private pageLoadStarted: number;
  private pageReadyLogged = false;
  constructor(
    private sharedService: SharedService,
    private activatedRouteroute: ActivatedRoute,
    private modalService: NgbModal,
    private router: Router,
    private alertService: AlertsService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.pageLoadStarted = performance.now();
    // Read alongside location preparation; never wait for optional storage.
    void loadMfaLogo().then(logo => { this.cachedLogo = logo; });
    localStorage.clear();
    sessionStorage.clear();
    this.navigaatorDetais();
    this.clientDetails = this.activatedRouteroute.snapshot.queryParams;
    this.activatedRouteroute.queryParams.subscribe((params) => {
      this.clientDetails = params;
    });

    const renderedIp = (window as Window & { minMfaClientIp?: string }).minMfaClientIp;
    // Accept only numeric addresses. An unprocessed SSI marker uses the old flow.
    let hasRenderedIp = typeof renderedIp === 'string' && renderedIp.length <= 45 &&
      /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$|^[0-9a-f]*:[0-9a-f:.]+$/i.test(renderedIp);
    if (hasRenderedIp) {
      try {
        new URL(`http://${renderedIp.includes(':') ? '[' + renderedIp + ']' : renderedIp}`);
      } catch {
        hasRenderedIp = false;
      }
    }
    if (hasRenderedIp) {
      this.locationDetails = { ip: renderedIp };
      this.logPageTiming('ip_from_document', this.pageLoadStarted);
      await this.checkLocationPermission();
      // The provider still supplies the full fallback address when precise location fails.
      if (!this.locationData) {
        await this.getIpDetails();
      }
    } else {
      // Deployments without server-provided IP retain both original location operations.
      await Promise.all([this.getIpDetails(), this.checkLocationPermission()]);
    }

    // Reverse geocoding takes precedence regardless of which request finishes first.
    // Its IP address comes from the document or the completed fallback IP lookup.
    if (this.locationData) {
      this.locationData.ipAddress = this.locationDetails?.ip || '';
      this.myLocation = JSON.stringify(this.locationData);
    }
    this.logPageTiming('location_ready', this.pageLoadStarted);

    // 3. Load MFA and user devices exactly once
    this.getUserDevices();
    this.getMfaDetails();
  }

  private logPageTiming(stage: string, started: number, outcome = 'completed') {
    console.info('MFA_PERF browser_stage', {
      stage,
      outcome,
      durationMs: Math.round((performance.now() - started) * 100) / 100,
    });
  }

  private logPageReady(outcome: string) {
    if (!this.pageReadyLogged && this.pageLoadStarted !== undefined) {
      this.pageReadyLogged = true;
      this.logPageTiming('initial_page_ready', this.pageLoadStarted, outcome);
      const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
      if (navigation) {
        console.info('MFA_PERF navigation_stage', {
          stage: 'document_to_mfa_response',
          outcome,
          durationMs: Math.round(performance.now() * 100) / 100,
          documentTtfbMs: Math.round((navigation.responseStart - navigation.requestStart) * 100) / 100,
          documentDownloadMs: Math.round((navigation.responseEnd - navigation.responseStart) * 100) / 100,
          beforeComponentMs: Math.round(this.pageLoadStarted * 100) / 100,
        });
        // Measure a paint opportunity after Angular handles the response.
        // This does not prove every MFA action is already usable.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.logPageTiming('document_to_mfa_paint_opportunity', 0, outcome);
        }));
      }
    }
  }
  resendPush() {
    this.close();
    this.sendPush(this.pushType, this.pushModelTemplate);
  }
  reload() {
    this.getUserDevices();
  }
  validateOTP() {
    this.verify = true;
    let url = MFA.OTP_MFA_VALIDATION;
    if (this.pushType == 'minPin') {
      this.mfaResponce = new Object();
      this.mfaResponce.trackingId = null;
    }
    let mfaOption = this.pushType;
    if (
      mfaOption == 'yubicoFido2' &&
      this.enableMfas?.OptionsGroupDTO.yubicoOtpEnabled
    ) {
      mfaOption = 'yubicoOtp';
    }
    let mfaDetailsObj = {
      id: null,
      mfaOption: mfaOption,
      requestId: this.clientDetails.requestId,
      deviceId: null,
      otp: this.otp,
      trackingId: this.mfaResponce.trackingId || null,
      active: true,
      minDeviceDetailsDTO: {
        id: null,
        deviceTypes: this.deviceType,
        deviceOperatingSystem: navigator.platform,
        mfaOptionAccessedLocationJson: this.myLocation,
        deviceRestrictions: JSON.stringify({
          password: null,
          jailbroken: false,
          touchId: false,
          latestOS: navigator.platform,
          browser: this.currentBrowser,
          browserVersion: this.browserVersion,
        }),
      },
    };
    this.sharedService
      .commonPostHandler(url, mfaDetailsObj)
      .subscribe((data) => {
        if (data.isValidOtp == true) {
          window.open(data.targetUrl, '_self');
          this.pushModel.close();
          this.alertService.success(`Logged in  successfully`);
        } else {
          this.otp = null;
          this.verify = false;
          this.alertService.error(`Invalid Verification Code`);
          if (this.counter == 0) {
            this.alertService.error(
              `Verification code got expired.Please try again later`,
            );
            this.pushModel.close();
          }
        }
      });
  }
  sendPush(mfaOption, content) {
    this.otp = this.displayWaringMessage = null;
    this.isPushNotificationsEnabled =
      this.yubicoManagerAccessRequestScreen = false;
    this.processing = true;
    this.isPushNotificationsEnabled =
      this.ShowOtpScreen =
      this.isFailedPushNotificationSent =
        this.yubicoManagerAccessRequestScreen;
    false;
    this.isTimeExpired = false;
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'md',
      centered: true,
    };
    switch (mfaOption) {
      case 'email':
        this.displayOptionType = 'Email';
        break;
      case 'yubicoFido2':
        this.displayOptionType = 'YubiKey';
        break;
      case 'face':
        this.displayOptionType = 'Face Recognition';
        break;
      case 'fingerPrint':
        this.displayOptionType = 'Finger Print';
        break;
      case 'phoneCall':
        this.displayOptionType = 'Phone Call';
        break;
      case 'otp':
        this.displayOptionType = 'Text Message';
        break;
      case 'minPin':
        this.displayOptionType = 'Min App Passcode';
        break;
      case 'minPrompt':
        this.displayOptionType = 'min Prompt';
        break;
      case 'yubicoManagerAccessRequest':
        this.displayOptionType = 'yubicoManagerAccessRequest';
        break;
    }
    if (mfaOption != 'yubicoManagerAccessRequest') {
      this.userManagerId = null;
      this.yubicoManagerAccessRequestScreen = false;
    } else {
      this.yubicoManagerAccessRequestScreen = true;
    }
    this.pushModelTemplate = content;

    this.pushType = mfaOption;
    if (mfaOption == 'minPin') {
      this.ShowOtpScreen = true;
      this.pushNotificationScreen = false;
      this.processing = false;
      this.pushModel = this.modalService.open(content, ngbModalOptions);
    } else {
      const obj = {
        id: null,
        mfaOption: mfaOption,
        deviceId: this.selectedDeviceId,
        requestId: this.clientDetails.requestId,
        active: true,
        userId: null,
        userManagerId: this.userManagerId,
        requestReason: this.requestReason,
        minDeviceDetailsDTO: {
          id: null,
          deviceTypes: this.deviceType,
          deviceOperatingSystem: navigator.platform,
          mfaOptionAccessedLocationJson: this.myLocation,
          deviceRestrictions: JSON.stringify({
            password: null,
            jailbroken: false,
            touchId: false,
            latestOS: navigator.platform,
            browser: this.currentBrowser,
            browserVersion: this.browserVersion,
          }),
        },
      };
      if (
        mfaOption == 'yubicoFido2' &&
        this.enableMfas?.OptionsGroupDTO.yubicoFidoEnabled
      ) {
        this.registerYubiKey(obj);
      } else {
        this.pushModel = this.modalService.open(content, ngbModalOptions);
        let url = MFA.REDIRECT_MFA;
        this.sharedService.commonPostHandler(url, obj).subscribe(
          (data) => {
            this.mfaResponce = data;
            this.processing = false;
            if (data.message == 'Push Notifications are not enabled') {
              this.pushNotificationScreen = true;
              this.isPushNotificationsEnabled = true;
              this.editDeviceNameModel.close();
            } else if (data.message == 'Failed to sent the push notification') {
              this.pushNotificationScreen = true;
              this.isFailedPushNotificationSent = true;
            } else if (
              data.message == 'Successfully sent the email to the manager.'
            ) {
              this.yubicoManagerAccessRequestScreen = true;
              this.editDeviceNameModel.close();
              this.x = 0;
              this.pushToMobile();
            } else {
              if (
                mfaOption == 'otp' ||
                mfaOption == 'email' ||
                mfaOption == 'yubicoFido2'
              ) {
                this.ShowOtpScreen = true;
                this.pushNotificationScreen = false;
                if (this.pushType != 'yubicoFido2') {
                  this.timer();
                }
              } else if (
                mfaOption == 'phoneCall' &&
                this.mfaResponce.isPhonecallPin == true
              ) {
                this.ShowOtpScreen = true;
              } else {
                this.pushNotificationScreen = true;
                this.ShowOtpScreen = false;
                this.x = 0;
                this.pushToMobile();
              }
            }
          },
          (err) => {
            this.processing = false;
            this.pushModel.close();
            this.alertService.error(`${err.error.title}`);
          },
        );
      }
    }
  }
  pushToMobile() {
    let MFA_PUSH_URL =
      MFA.LOGIN_PUSH_MFA +
      '?' +
      'trackingId=' +
      this.mfaResponce.trackingId +
      '&' +
      'requestId=' +
      this.clientDetails.requestId;
    let location = JSON.parse(this.myLocation);
    let obj = {
      city: location.city,
      country: location.country,
      state: location.state,
      ipAddress: location.ipAddress,
      zipCode: location.zipCode,
    };
    this.sharedService.commonPostHandler(MFA_PUSH_URL, obj).subscribe(
      (res) => {
        if (res.isAuthenticated == true) {
          this.pushModel.close();
          window.open(res.targetUrl, '_self');
          this.alertService.success(`Logged in  successfully`);
        } else if (
          res.message &&
          res.message == 'Access Denied – Two Factor Authentication Failed.'
        ) {
          this.alertService.error(res.message);
          this.pushNotificationScreen = false;
          this.pushModel.close();
        } else if (res.deviceDetails && res.message) {
          this.displayWaringMessage = res.deviceDetails.message;
          if (res.mfaOptionsStatus != null) {
            this.enableMfas.OptionsGroupDTO = res.mfaOptionsStatus;
            //this.pushModel.close();
          }
        } else if (
          res.message &&
          res.displayMessage &&
          res.message == 'Yubico custom message'
        ) {
          this.displayWaringMessage = res.displayMessage;
          if (res.mfaOptionsStatus != null) {
            this.enableMfas.OptionsGroupDTO = res.mfaOptionsStatus;
            this.enableMfas.isForgotYubicoEnable = res.isForgotYubicoEnable;
          }
        } else {
          if (this.x != 100) {
            this.x++;
            if (this.pushType == 'yubicoManagerAccessRequest') {
              setTimeout(() => {
                this.pushToMobile();
              }, 5000);
            } else {
              if (this.x < 12) {
                setTimeout(() => {
                  this.pushToMobile();
                }, 5000);
              } else {
                this.alertService.error(`Authentiaction Failed`);
                this.pushNotificationScreen = false;
                this.x = 0;
                this.pushModel.close();
              }
            }
          }
        }
      },
      (err) => {
        this.alertService.error(`Authentiaction Failed`);
      },
    );
  }
  close() {
    this.x = 100;
    this.pushModel.close();
    this.processing = false;
  }
  enterKey(event) {
    if (event.keyCode === 13) {
      this.validateOTP();
    }
  }
  addDevice(addDevice) {
    this.emailSent = null;
    if (this.userDevices.length == 0) {
      this.enrollNew();
    }
    let ngbModalOptions: NgbModalOptions = {
      // backdrop: 'static',
      // keyboard: false,browserVersion
      size: 'lg',
      centered: true,
    };
    this.modalService.open(addDevice, ngbModalOptions);
  }
  getUserDevices(type?: any) {
    const url =
      USER.GET_USER_DEVICE +
      '/' +
      'mfa?' +
      'requestId=' +
      this.clientDetails.requestId;
    if (type == 'refresh') {
      this.loading = true;
    }
    this.sharedService.commonGetHandler(url).subscribe(
      (data) => {
        // this.userDevices = data;
        if (type == 'refresh') {
          this.loading = false;
        }
        this.isDeviceExists = data.isDeviceExists;
        this.userDevices = data.deviceDetails;
        this.isNewDeviceRegistered = data.newDeviceRegistered;
        this.isShowInstructionsToUpgrade = false;
        if (!this.isShowInstructionsToUpgrade && !this.isNewDeviceRegistered) {
          this.isShowInstructionsToUpgrade = true;
        } else {
          this.isShowInstructionsToUpgrade = false;
        }
        this.userDevices = data.deviceDetails;
        if (data?.deviceDetails?.length) {
          this.userDevices = data.deviceDetails;
          // this.userDevices = data.deviceDetails.filter((device: any) => device.isLatest === true);
        } else {
          this.userDevices = [];
        }
        if (this.userDevices.length != 0) {
          let selectedDeviceDetails = this.userDevices.filter(
            (a) => a.defaultDevice == true,
          );
          if (selectedDeviceDetails.length != 0) {
            this.selectedDeviceId = selectedDeviceDetails[0].deviceId;
            this.selectedDeviceName = selectedDeviceDetails[0].deviceName;
          } else {
            this.selectedDeviceId = this.userDevices[0].deviceId;
            this.selectedDeviceName = this.userDevices[0].deviceName;
            this.defaultDevice = true;
          }
        }
      },
      (err) => {
        this.loading = false; // Stop the loading spinner in case of error

        if (err.status === 400) {
          // Bad Request
          console.error('Bad Request: Invalid request data.', err.error);
        } else if (err.status === 401) {
          // Unauthorized
          console.error(
            'Unauthorized: Invalid credentials or token.',
            err.error,
          );
          // Optionally, redirect to login or refresh token
        } else if (err.status === 404) {
          // Not Found
          console.error(
            'Not Found: The requested resource could not be found.',
            err.error,
          );
        } else if (err.status === 500) {
          // Internal Server Error
          console.error(
            'Internal Server Error: Something went wrong on the server.',
            err.error,
          );
        } else if (err.status === 503) {
          this.isUnderMaintainance = true;
        } else if (err.status === 504) {
          setTimeout(() => {
            this.getUserDevices();
          }, 2000);
        } else {
          // Other errors
          console.error('An unknown error occurred:', err);
        }

        this.processing = false;
      },
    );
  }
  chnageDeviceDetails() {
    let selectedDeviceDetails = this.userDevices.filter(
      (a) => a.deviceId == this.selectedDeviceId,
    );
    this.selectedDeviceName = selectedDeviceDetails[0].deviceName;
  }
  deleteUserDevice(id) {
    const url = USER.DELETE_DEVICE + '/' + id;
    this.sharedService.commonDeleteHandler(url).subscribe((data) => {
      this.getUserDevices('refresh');
    });
  }
  enrollNew() {
    const ipUrl =
      'https://api.ipapi.com/check?access_key=3f6f89e6f1cc29a4cf281e9ee785fce6&format=1';
    const url =
      USER.SEND_INVITATION +
      '/' +
      'mfa?' +
      'requestId=' +
      this.clientDetails.requestId;
    this.sharedService
      .commonPostHandler(url, this.locationData)
      .subscribe((data) => {
        this.emailSent = data.message;
        this.alertService.success(`Email sent to your mail.`);
      });
  }
  getIpDetails(): Promise<void> {
    const started = performance.now();
    this.displayErrMsg = null;
    const ipUrl =
      'https://api.ipapi.com/check?access_key=3f6f89e6f1cc29a4cf281e9ee785fce6&format=1';

    return new Promise((resolve) => {
      this.sharedService.commonGetHandler(ipUrl).subscribe(
        (location) => {
          this.locationDetails = location;
          let obj = {
            city: location?.city || location?.country_name || '',
            country: location?.country_name || location?.country || '',
            state: location?.region_name || location?.state || '',
            ipAddress: location?.ip || this.locationDetails || '',
            zipCode: location?.zip || location?.zipCode || '',
          };
          this.myLocation = JSON.stringify(obj);
          this.logPageTiming('ip_lookup', started);
          resolve();
        },
        (err) => {
          console.warn('IP details fetch failed:', err);
          this.logPageTiming('ip_lookup', started, 'failed');
          resolve();
        },
      );
    });
  }
  getMfaDetails() {
    const started = performance.now();
    this.loading = true;
    if (!this.clientDetails?.requestId) {
      this.clientDetails = this.activatedRouteroute.snapshot.queryParams;
    }
    let mfaDetailsObj = {
      id: null,
      mfaOption: null,
      requestId: this.clientDetails?.requestId,
      deviceId: null,
      active: true,
      userId: null,
      minDeviceDetailsDTO: {
        id: null,
        deviceTypes: this.deviceType,
        deviceOperatingSystem: navigator.userAgent,
        applicationAccessedLocationJson: this.myLocation,
        deviceRestrictions: JSON.stringify({
          password: null,
          jailbroken: false,
          touchId: false,
          latestOS: navigator.platform,
          browser: this.currentBrowser,
          browserVersion: this.browserVersion,
        }),
      },
    };
    // Capture the advertised image for this request even if storage finishes later.
    const cachedLogo = this.cachedLogo;
    const mfaUrl = USER.ENABLE_MFAS + '?logoCache=true' +
      (cachedLogo ? '&cachedLogoHash=' + cachedLogo.hash : '');
    this.sharedService.commonPostHandler(mfaUrl, mfaDetailsObj).subscribe(
      (data) => {
        if (data.logoNotModified === true && cachedLogo && cachedLogo.hash === data.logoHash) {
          data.logo = cachedLogo.logo;
        } else if (typeof data.logo === 'string' && typeof data.logoHash === 'string') {
          void saveMfaLogo({ hash: data.logoHash, logo: data.logo });
        }
        this.loading = false;
        this.logPageTiming('application_mfa', started, data.error == null ? 'completed' : 'policy_error');
        this.logPageReady(data.error == null ? 'completed' : 'policy_error');
        if (data.error == null) {
          this.enableMfas = data;
          if (data.targetUrl) {
            setTimeout(() => {
              window.open(data.targetUrl, '_self');
            }, 3000);
          } else {
            localStorage.setItem(
              'yubicoAuthenticationResponse',
              this.enableMfas.yubicoKeyObject,
            );
            if (
              this.enableMfas &&
              !this.enableMfas.mfaOptionsColorFontThemeDTO
            ) {
              this.enableMfas.mfaOptionsColorFontThemeDTO = {
                iconColor: '#328476',
                buttonColor: '#328476',
                fontColor: '#303030',
              };
            }
          }
        } else {
          this.displayErrMsg = data.error.displayMessage;
        }
      },
      (err) => {
        this.loading = false;
        this.logPageTiming('application_mfa', started, 'failed');
        this.logPageReady('failed');
        this.displayErrMsg = err?.error?.title || err?.error?.displayMessage || 'An error occurred while enabling MFA';
      },
    );
  }
  navigaatorDetais() {
    //var nVer = navigator.appVersion;
    console.log(navigator.userAgent);
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      this.deviceType = 'Mobile';
    } else {
      this.deviceType = 'Desktop';
    }
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      browserName = 'Microsoft Internet Explorer';
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }
    this.currentBrowser = browserName;
    this.browserVersion = fullVersion;
  }
  timer() {
    this.verify = false;
    this.counter = 120;
    let intervel = setInterval(() => {
      this.counter = this.counter - 1;
      if (this.counter == 0) {
        clearInterval(intervel);
        if (this.verify == false) {
          this.alertService.error(
            `Verification code got expired.Please try again later`,
          );
          this.pushModel.close();
        }
      }
    }, 1000);
  }

  editDeviceName(editDevice, id) {
    let editDeviceDetails = this.userDevices.filter((a) => a.deviceId == id);
    this.editDeviceDetails = editDeviceDetails[0];
    this.deviceName = editDeviceDetails[0].deviceName;
    let ngbModalOptions: NgbModalOptions = {
      // backdrop: 'static',
      // keyboard: false,
      size: 'sm',
      centered: true,
    };
    this.editDeviceNameModel = this.modalService.open(
      editDevice,
      ngbModalOptions,
    );
  }
  updateDeviceName(item) {
    if (item) {
      this.deviceName = item.deviceName;
      var deviceId = item.deviceId;
      this.defaultDevice = true;
    } else {
      var deviceId = this.editDeviceDetails.deviceId;
    }
    let url =
      BASIC.API +
      'device/display/name?name=' +
      this.deviceName +
      '&deviceId=' +
      deviceId +
      '&defaultDevice=' +
      this.defaultDevice;
    this.sharedService.commonPutHandler(url, null).subscribe((data) => {
      this.getUserDevices('refresh');
      if (item) {
        this.alertService.success(`Default device updated successfully`);
      } else {
        this.alertService.success(`Device Name updated successfully`);
      }
      this.editDeviceNameModel.close();
    });
  }
  requestLogin(content) {
    this.processing = this.isManagerAccessRequired = true;
    this.userManagerId = this.requestReason = null;
    let ngbModalOptions: NgbModalOptions = {
      size: 'md',
      centered: true,
    };
    this.editDeviceNameModel = this.modalService.open(content, ngbModalOptions);
    let mfaDetailsObj = {
      id: null,
      mfaOption: 'yubicoManagerAccessRequest',
      requestId: this.clientDetails.requestId,
      deviceId: this.selectedDeviceId,
      active: true,
      userId: null,
      minDeviceDetailsDTO: {
        id: null,
        deviceTypes: this.deviceType,
        deviceOperatingSystem: navigator.userAgent,
        applicationAccessedLocationJson: this.myLocation,
        deviceRestrictions: JSON.stringify({
          password: null,
          jailbroken: false,
          touchId: false,
          latestOS: navigator.platform,
          browser: this.currentBrowser,
          browserVersion: this.browserVersion,
        }),
      },
    };
    let url = BASIC.API + 'mfa/direct/access/request';
    this.sharedService
      .commonPostHandler(url, mfaDetailsObj)
      .subscribe((data) => {
        if (data.isAuthenticated == true) {
          this.isManagerAccessRequired = false;
          this.processing = false;
          setTimeout(() => {
            this.alertService.success(`Logged in  successfully`);
            window.open(data.targetUrl, '_self');
            this.pushModel.close();
          }, 3000);
        } else {
          this.isManagerAccessRequired = true;
          this.processing = false;
          this.getManagesList();
        }
      });
  }

  sendRequest() {
    const url =
      BASIC.API +
      'mfa/managers?requestId=' +
      this.clientDetails.requestId +
      '&userId=' +
      this.selcetedManager;
    this.sharedService.commonPostHandler(url, null).subscribe((data) => {
      this.emailSent = data.message;
      this.alertService.success(`Email sent to your mail.`);
    });
  }
  getManagesList() {
    const url =
      BASIC.API + 'mfa/managers?requestId=' + this.clientDetails.requestId;
    this.sharedService.commonGetHandler(url).subscribe((data) => {
      this.managersList = data;
    });
  }

  /// Yubi Key

  registeredCredentials(): PublicKeyCredentialDescriptorJSON[] {
    return this.getRegistrations().map((reg) => ({
      id: reg.rawId,
      type: reg.type,
    }));
  }

  async register(data): Promise<void> {
    const cco = parseCreationOptionsFromJSON({
      publicKey: {
        challenge: data.challenge,
        rp: { name: data.rp.name },
        user: {
          id: data.user.id,
          name: data.user.name,
          displayName: data.user.displayName,
        },
        pubKeyCredParams: data.pubKeyCredParams,
        excludeCredentials: this.registeredCredentials(),
        authenticatorSelection: data.authenticatorSelection,
        extensions: {
          credProps: true,
        },
      },
    });
    this.saveRegistration(await create(cco));
    this.authenticate();
  }

  async authenticate(): Promise<void> {
    let yubicoAuthenticationResponse = JSON.parse(
      localStorage.getItem('yubicoAuthenticationResponse'),
    );
    const cro = parseRequestOptionsFromJSON({
      publicKey: {
        challenge: yubicoAuthenticationResponse.publicKey.challenge,
        allowCredentials: this.registeredCredentials(),
        userVerification: 'discouraged',
        extensions: yubicoAuthenticationResponse.publicKey.extensions,
        rpId: yubicoAuthenticationResponse.publicKey.rpId,
      },
    });
    await this.get(cro);
  }

  async testSupported() {
    document.querySelector('#supported .status')!.textContent = '…';
    document.querySelector('#supported .status')!.textContent = supported()
      ? ' ✅'
      : ' ❌';
  }

  registerYubiKey(obj) {
    let url = BASIC.API + 'redirect/register/start';
    this.sharedService.commonPostHandler(url, obj).subscribe(async (data) => {
      if (this.enableMfas.isYubicoKeyRegistered == true) {
        localStorage.webauthnExampleRegistrations = JSON.stringify(
          [data],
          null,
          '  ',
        );
        let yubicoAuthenticationResponse = JSON.parse(
          this.enableMfas.yubicoKeyObject,
        );
        const cro = parseRequestOptionsFromJSON({
          publicKey: {
            challenge: yubicoAuthenticationResponse.publicKey.challenge,
            allowCredentials:
              yubicoAuthenticationResponse.publicKey.allowCredentials,
            userVerification: 'discouraged',
            extensions: yubicoAuthenticationResponse.publicKey.extensions,
            rpId: yubicoAuthenticationResponse.publicKey.rpId,
          },
        });
        await this.get(cro);
        localStorage.setItem(
          'yubicoAuthenticationResponse',
          this.enableMfas.yubicoKeyObject,
        );
      } else {
        this.yubiKeyRegistrationObject = data;
        this.register(data);
      }
    });
  }
  getRegistrations(): RegistrationResponseExtendedJSON[] {
    const registrations = JSON.parse(
      localStorage.webauthnExampleRegistrations || '[]',
    );
    return registrations;
  }

  setRegistrations(
    registrations: RegistrationResponseExtendedJSON[],
    display: boolean = true,
  ): void {
    this.completeRegistartion(registrations);
    localStorage.webauthnExampleRegistrations = JSON.stringify(
      registrations,
      null,
      '  ',
    );
    this.displayRegistrations();
  }

  saveRegistration(registration: RegistrationPublicKeyCredential): void {
    const registrations = this.getRegistrations();
    registrations.push(registration.toJSON());
    this.setRegistrations(registrations);
  }

  registrationElem(): HTMLTextAreaElement {
    return document.querySelector('#registrations')! as HTMLTextAreaElement;
  }

  displayRegistrations() {
    this.registrationElem().value = JSON.stringify(
      this.getRegistrations(),
      null,
      '  ',
    );
  }

  withStatus(selector: string, fn: () => Promise<void>) {
    return async function () {
      document.querySelector('#error')!.textContent = '';
      document.querySelector(selector)!.textContent = '…';
      try {
        await fn();
        document.querySelector(selector)!.textContent = ' ✅';
      } catch (e) {
        document.querySelector(selector)!.textContent = ' ❌';
        console.error(e);
        document.querySelector('#error')!.textContent = e;
      }
    };
  }

  async saveInput(): Promise<void> {
    document.querySelector('#error')!.textContent = '';
    this.registrationElem().style.backgroundColor = 'rgba(255, 127, 0, 0.5)';
    try {
      this.setRegistrations(JSON.parse(this.registrationElem().value), false);
      this.registrationElem().style.backgroundColor = 'rgba(0, 255, 0, 0.5)';
    } catch (e) {
      this.registrationElem().style.backgroundColor = 'rgba(255, 0, 0, 0.5)';
      console.error(e);
      document.querySelector('#error')!.textContent = e;
    }
  }

  completeRegistartion(data) {
    let url = BASIC.API + 'redirect/register/finish';
    let obj = {
      id: null,
      mfaOption: this.pushType,
      requestId: this.clientDetails.requestId,
      deviceId: null,
      otp: this.otp,
      trackingId: null,
      active: true,
      minDeviceDetailsDTO: {
        id: null,
        deviceTypes: this.deviceType,
        deviceOperatingSystem: navigator.platform,
        mfaOptionAccessedLocationJson: this.myLocation,
        deviceRestrictions: JSON.stringify({
          password: null,
          jailbroken: false,
          touchId: false,
          latestOS: navigator.platform,
          browser: this.currentBrowser,
          browserVersion: this.browserVersion,
        }),
      },
      publicKeyCredentialRequestDTO: {
        publicKeyCredentialsJson: data,
        publicKeyCredentialsOptions: {
          rp: this.yubiKeyRegistrationObject.rp,
          user: this.yubiKeyRegistrationObject.user,
          challenge: this.yubiKeyRegistrationObject.challenge,
          pubKeyCredParams: this.yubiKeyRegistrationObject.pubKeyCredParams,
          timeout: null,
          excludeCredentials: this.yubiKeyRegistrationObject.excludeCredentials,
          authenticatorSelection:
            this.yubiKeyRegistrationObject.authenticatorSelection,
          attestation: this.yubiKeyRegistrationObject.attestation,
          extensions: this.yubiKeyRegistrationObject.extensions,
        },
      },
    };
    this.sharedService.commonPostHandler(url, obj).subscribe((data) => {
      this.yubicoAuthenticationResponse = data;
      localStorage.setItem(
        'yubicoAuthenticationResponse',
        JSON.stringify(this.yubicoAuthenticationResponse),
      );
      this.authenticate();
    });
  }
  authenticateFido() {
    let url = BASIC.API + 'redirect/authentication/finish';
    let obj = {
      id: null,
      mfaOption: this.pushType,
      requestId: this.clientDetails.requestId,
      deviceId: null,
      otp: this.otp,
      trackingId: null,
      active: true,
      minDeviceDetailsDTO: {
        id: null,
        deviceTypes: this.deviceType,
        deviceOperatingSystem: navigator.platform,
        mfaOptionAccessedLocationJson: this.myLocation,
        deviceRestrictions: JSON.stringify({
          password: null,
          jailbroken: false,
          touchId: false,
          latestOS: navigator.platform,
          browser: this.currentBrowser,
          browserVersion: this.browserVersion,
        }),
      },
      publicKeyCredentialRequestDTO: {
        publicKeyCredentialJson: this.fido2AuthenticationObject,
        publicKey: JSON.parse(
          localStorage.getItem('yubicoAuthenticationResponse'),
        ),
      },
      username: null,
    };

    this.sharedService.commonPostHandler(url, obj).subscribe((data) => {
      if (data.isAuthenticated == true) {
        window.open(data.targetUrl, '_self');
      } else {
        this.alertService.error(`Invalid Verification`);
        if (this.counter == 0) {
          this.alertService.error(`Invalid YubiKey.Please try again later`);
        }
      }
    });
  }

  async create(
    options: CredentialCreationOptions,
  ): Promise<RegistrationPublicKeyCredential> {
    const response = (await navigator.credentials.create(
      options,
    )) as RegistrationPublicKeyCredential;
    response.toJSON = () => createResponseToJSON(response);
    return response;
  }

  async get(
    options: CredentialRequestOptions,
  ): Promise<AuthenticationPublicKeyCredential> {
    const response = (await navigator.credentials.get(
      options,
    )) as AuthenticationPublicKeyCredential;
    response.toJSON = () => getResponseToJSON(response);
    console.log(JSON.stringify(response));
    localStorage.setItem('yubiAFterlogin', JSON.stringify(response));
    this.fido2AuthenticationObject = response;
    this.authenticateFido();
    return response;
  }
  // checkLocationPermission() {
  //   this.isShowInstructionsToUpgrade = false;
  //   navigator.geolocation.getCurrentPosition(
  //     (position) => {
  //       this.reverseGeocode(
  //         position.coords.latitude,
  //         position.coords.longitude,
  //       );
  //     },
  //     (error) => {
  //       return;
  //     },
  //     { enableHighAccuracy: true, maximumAge: 10000 },
  //   );
  //   navigator.permissions.query({ name: 'geolocation' }).then((result) => {
  //     if (result.state === 'denied') {
  //       this.showLocationModal();
  //     } else {
  //       navigator.geolocation.getCurrentPosition(
  //         (position) => {
  //           console.log('Location accessed:', position);
  //           this.getUserDevices();
  //         },
  //         (error) => {
  //           if (error.code === error.PERMISSION_DENIED) {
  //             this.showLocationModal();
  //           }
  //         },
  //       );
  //     }
  //   });
  // }
  checkLocationPermission(): Promise<void> {
    const started = performance.now();
    this.isShowInstructionsToUpgrade = false;

    if (!navigator.geolocation) {
      this.logPageTiming('geolocation', started, 'unavailable');
      this.showLocationModal();
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          this.logPageTiming('geolocation', started);
          console.log('Location success:', position);

          const { latitude, longitude } = position.coords;

          await this.reverseGeocode(latitude, longitude);
          resolve();
        },
        (error) => {
          this.logPageTiming('geolocation', started, 'failed');
          console.error('Location error:', error);

          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.showLocationModal();
              break;

            case error.POSITION_UNAVAILABLE:
              console.warn('Location unavailable');
              this.showLocationModal();
              break;

            case error.TIMEOUT:
              console.warn('Location timeout');
              this.showLocationModal();
              break;
          }
          resolve();
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
    });
  }

  showLocationModal() {
    const modalElement = document.getElementById('locationPermissionModal');
    if (modalElement && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      const modal = new bootstrap.Modal(modalElement, {
        backdrop: 'static', // disable outside click to close
        keyboard: false, // disable ESC to close
        focus: true,
      });
      modal.show();
    }
  }

  async closeModal() {
    const modalElement = document.getElementById('locationPermissionModal');
    if (modalElement && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      modalInstance?.hide();
    }
    await this.checkLocationPermission();
  }

  // async reverseGeocode(latitude, longitude) {
  //   const link = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`;

  //   try {
  //     const response = await fetch(link);
  //     const data = await response.json();
  //     console.log("location Detailed for IP Address::", this.locationDetails)
  //     let locationDetailsDTO = {
  //       city: data.address.city,
  //       country: data.address.country,
  //       state: data.address.state,
  //       ipAddress: this.locationDetails.ip,
  //       //ipAddress: '122.22.22',
  //       zipCode: data.address.postcode,
  //     };
  //     this.locationData = locationDetailsDTO;
  //     console.log('assign location details', this.locationData);
  //     return data;
  //   } catch (err) {
  //     console.error('Error fetching reverse geocoding data:', err);
  //   }
  // }
  closeInstructions(type: any) {
    if (type == 'skip') {
      this.isShowInstructionsToUpgrade = false;
    } else {
      this.getUserDevices('refresh');
      this.isShowInstructionsToUpgrade = false;
    }
  }

  async reverseGeocode(
    latitude,
    longitude,
    maxRetries = 5,
    retryDelay = 1000,
  ): Promise<any> {
    const started = performance.now();
    const link = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`;

    let attempt = 0;
    let data = null;

    while (attempt < maxRetries) {
      try {
        const response = await fetch(link);
        if (!response.ok) throw new Error('HTTP error: ' + response.status);
        data = await response.json();

        if (data && data.address) {
          this.locationData = {
            city:
              data.address.city ||
              data.address.town ||
              data.address.village ||
              '',
            country: data.address.country || '',
            state: data.address.state || '',
            ipAddress: this.locationDetails?.ip || '',
            zipCode: data.address.postcode || '',
          };
          this.myLocation = JSON.stringify(this.locationData);
          console.log('assign location details', this.locationData);
          this.logPageTiming('reverse_geocode', started);
          return data;
        }
      } catch (err) {
        console.warn(`Attempt ${attempt + 1} failed:`, err);
      }

      attempt++;
      if (attempt < maxRetries) {
        await new Promise((resolve) => setTimeout(resolve, retryDelay)); // wait before retrying
      }
    }

    console.error(
      'Failed to fetch reverse geocode data after multiple attempts',
    );
    this.logPageTiming('reverse_geocode', started, 'failed');
    return null;
  }

  setGeoLocation(position: { coords: { latitude: any; longitude: any } }) {
    const {
      coords: { latitude, longitude },
    } = position;
    const geocodingData = this.reverseGeocode(
      position.coords.latitude,
      position.coords.longitude,
    );
  }
}

import { AfterViewInit, Directive } from '@angular/core';
import { RegistrationResponseExtendedJSON } from '../webauthn-json/browser-ponyfill.extended';

@Directive({
  selector: 'autofocus',
  standalone: false,
})
export class AutoFocus implements AfterViewInit {
  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    this.elementRef.nativeElement.focus();
  }
}
